var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconModelMultipleSendTag = function SvgIconModelMultipleSendTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_model_multiple_send_tag_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M1.992 8.977V6.992h6.016v1.985zm8.016 2.03H-.008V4.993h10.016v1.016h-9v3.984h9zm6-6.015v6.016h-3.016V9.992h2V6.008h-2V4.992zm-4 7.25q.867.75 1.992.75h.008v1.016H14a3.96 3.96 0 0 1-2.484-.86 4.1 4.1 0 0 1-1.18.641A4 4 0 0 1 9 14.008h-.008v-1.016H9q1.133 0 1.992-.726V3.703a2.8 2.8 0 0 0-.906-.515A3.5 3.5 0 0 0 9 3.008h-.008V1.992H9q.711 0 1.344.211.633.21 1.172.617 1.078-.828 2.484-.828h.008v1.016H14q-1.156 0-1.992.719z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_model_multiple_send_tag_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgIconModelMultipleSendTag;